import React from 'react';
import { themeStore } from 'Models/ThemeStore';
import { stringIsEmpty } from 'Util/TypeGuards';
import { HexToRgb } from 'Views/Components/Helpers/ColoursHelper';
import Icon from 'Views/Components/_HumanWritten/Icon/Icon';

export interface AddOnSectionCardProps {
	name: string;
	iconName?: string;
	colour?: string;
	information?: string;
	children?: React.ReactNode;
}

export function AddOnSectionCard({ name, iconName, colour, information, children }: AddOnSectionCardProps) {
	const rgb = HexToRgb(colour || '');
	const brandPrimary = HexToRgb(themeStore.config.brandColourPrimary);
	const fallbackRgb = brandPrimary ?? { r: 0, g: 0, b: 0 };
	const accent = rgb ?? fallbackRgb;
	const iconBg = `rgba(${accent.r}, ${accent.g}, ${accent.b}, 0.2)`;
	const iconFg = `rgb(${accent.r}, ${accent.g}, ${accent.b})`;

	return (
		<section className="add-on-section__container">
			<header className="booking-section-header add-on-section__title">
				<span className="booking-section-heading__icon" style={{ backgroundColor: iconBg, color: iconFg }}>
					<Icon name={iconName || 'library_add'} useMaterialIcons />
				</span>
				<div className="booking-section-header__text add-on-section__title-description">
					<h4 className="booking-section-title add-on-section__header">{name}</h4>
					{!stringIsEmpty(information) && (
						<p className="booking-section-description add-on-section__description">{information}</p>
					)}
				</div>
			</header>
			{children && <div className="add-ons-input-counter-container">{children}</div>}
		</section>
	);
}
